import type { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import { SortedEntityField } from './SortedEntityField';

/**
 * SortedEntityField, hardcoded to kind: Group - same relationship OwnerPicker
 * has to EntityPicker upstream. See SortedEntityField for why sorting is
 * needed at all.
 */
export const SortedOwnerField = (
  props: FieldExtensionComponentProps<string>,
) => (
  <SortedEntityField
    {...props}
    uiSchema={{
      ...props.uiSchema,
      'ui:options': {
        ...(props.uiSchema?.['ui:options'] as object | undefined),
        catalogFilter: { kind: 'Group' },
      },
    }}
  />
);
